import React, {useEffect, useState} from "react";
import {
    Box,
    Heading,
    Text,
    VStack,
    HStack,
    Button,
    useColorModeValue,
    chakra, useToast, Image
} from "@chakra-ui/react";
import {ScreenContainer} from "../container/ScreenContainer";

import { Header as Nav } from "../header/Header";
import { Footer } from "../footer/Footer";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import OrderDetailDataProvider from "../dataProviderEvo/order-detail-data-provider";

import { PAYMENT_CARD, PAYMENT_BANK_TRANSFER, PAYMENT_CODE} from "../../infrastructure/utils/formUtils";
import {ROUTE_MAIN, ROUTE_PARAM_ORDER} from "../../App";
import {SubscriptionActivatedContent} from "./PurchaseByCodeConfirmation";
import {PayedMsg} from "./PaymentByCardStates";


export const PurchaseConfirmation = ({ orderHashParam = null, innerContentOnly = false, showMenu = true}) => {

    const toast = useToast();

    const Navigate = useNavigate();
    const { orderId } = useParams();

    const [orderHash, setOrderHash] = useState((orderHashParam !== null ? orderHashParam : orderId));
    const [orderData, setOrderData] = useState([]);

    useEffect(() => {

        if(orderHash === undefined || orderHash === null || orderHash == ''){
            Navigate(ROUTE_MAIN);

            toast({
                description: 'Stránka, kterou hledáte, neexistuje, nebo k ní nemáte přístup.',
                status: 'info',
                duration: 3000, // Doba zobrazení toastu v milisekundách
                isClosable: true, // Uživatel může toast zavřít
                position: "top"
            });

        } else if (Object.keys(orderData).length  == 0) {
            let dp = new OrderDetailDataProvider();
            dp.getData(orderHash, {}, {}).then((res) => {
                if (res && res.status === 'OK') {
                    setOrderData(res.data);
                } else {
                    toast({
                        title: 'Při načítání objednavky došlo k potížím',
                        description: res.errors[0],
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }

            });
        }

    }, [orderHash]);

    let bgColor = useColorModeValue('#f9f9f9', '#1a202c');

    return (
        <>
       <Box
            bg={bgColor}
            height={(innerContentOnly ? "auto" : "100vh")}
            justifyContent="center"
            alignItems="center"
        >
           {!innerContentOnly && (<Nav />)}
           {(Object.keys(orderData).length  > 0) && (
            <ScreenContainer pb={!innerContentOnly ? "250px" : "0"}>
                {!innerContentOnly && <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                    {(orderData.payment_method.code == PAYMENT_BANK_TRANSFER || (orderData.payment_method.code == PAYMENT_CARD && orderData.payment_gateway_payment?.state?.code != 2))  && ("Pro dokončení objednávky Vinařského obzoru zbývá jen zaplatit")}
                    {/*{(orderData.payment_method.code == PAYMENT_CARD && orderData.payment_gateway_payment?.state?.code == 2)  && ("Pro dokončení objednávky Vinařského obzoru zbývá jen zaplatit")}*/}
                    {(orderData.payment_method.code == PAYMENT_CODE || (orderData.payment_method.code == PAYMENT_CARD && orderData.payment_gateway_payment?.state?.code == 2)) && ("Děkujeme za aktivaci předplatného")}
                </chakra.h1>}

            <Box
                width="100%"
                maxW="800px"
                mx="auto"
                bg="white"
                borderRadius="lg"
                background={"white"}
                padding={10}
                boxShadow="md"
                borderRadius={10}
            >
                <VStack spacing={4} align="stretch">
                    <HStack justifyContent="space-between">
                        <Text fontWeight="bold">Číslo objednávky:</Text>
                        <Text>{orderData.order_number}</Text>
                    </HStack>

                    <HStack justifyContent="space-between">
                        <Text fontWeight="bold">Způsob platby:</Text>
                        <Text>{orderData.payment_method.value}</Text>
                    </HStack>

                    {orderData.payment_method.code != PAYMENT_CODE && (<HStack justifyContent="space-between">
                        <Text fontWeight="bold">Celková částka:</Text>
                        <Text>{orderData.price.total}{" Kč "}</Text>
                    </HStack>)}
                    <>
                    {orderData.payment_method.code == PAYMENT_CARD && orderData.payment_gateway_payment?.redirect_url && orderData.payment_gateway_payment?.state?.code != 2 && (
                            <>
                                {showMenu && (<Button
                                    size="lg"
                                    colorScheme="pink"
                                    onClick={() => window.location.href =  orderData.payment_gateway_payment.redirect_url}
                                >
                                    {"Zaplatit kartou"}
                                </Button>)}
                            </>
                    )}

                        {orderData.payment_method.code == PAYMENT_CARD && orderData.payment_gateway_payment?.state?.code == 2 && (
                            <Box textAlign={"center"}>
                                <PayedMsg />
                            </Box>
                        )}

                    {orderData.payment_method.code == PAYMENT_BANK_TRANSFER && (
                        <BankInfo orderData={orderData} />
                    )}

                    {orderData.payment_method.code == PAYMENT_CODE && showMenu && (
                        <SubscriptionActivatedContent />
                    )}
                    </>
                </VStack>
                {/*<Text mt={6} textAlign="center" fontSize="lg">*/}
                {/*    Vaše objednávka byla úspěšně dokončena. Brzy obdržíte e-mail s potvrzením a dalšími podrobnostmi.*/}
                {/*</Text>*/}
                {showMenu && (<Button
                    mt={6}
                    width="full"
                    colorScheme="pink"
                    onClick={() => window.location.href = "/"}
                >
                    Zpět na domovskou stránku
                </Button>)}
            </Box>
            </ScreenContainer>
           )}
           {!innerContentOnly && (<Footer />)}
        </Box>
        </>
    );
};

// export default PurchaseConfirmation;


export const BankInfo = ({orderData}) => {
    return (<>
        <HStack justifyContent="space-between">
            <Text fontWeight="bold">Číslo účtu pro provedení platby:</Text>
            <Text>{orderData.bank_account.account_with_prefix_and_bank}{" (" + orderData.bank_account.bank_code.VALUE + ")"}</Text>
        </HStack>
        <HStack justifyContent="space-between">
            <Text fontWeight="bold">IBAN:</Text>
            <Text>{orderData.bank_account.iban}</Text>
        </HStack>

        <Box display="flex" flexDirection={"column"} alignItems={"center"} justifyContent="center" mt={4}>
            <Text fontSize={"lg"} py={3}>{"QR platba"}</Text>
            <Image src={orderData.bank_account.qr} alt="QR Code" boxSize="150px" objectFit="contain"/>
        </Box>
    </>)
}
